// frontend/src/screens/AgencyLoginScreen.jsx
import { useState } from 'react';
import axios from 'axios';
import { startAuthentication } from '@simplewebauthn/browser';
import { useNavigate } from 'react-router-dom';

export default function AgencyLoginScreen() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    setMessage('');
    try {
      // Step 1: Get WebAuthn login options from backend
      const { data: options } = await axios.post(
        '/api/agency/generate-agency-login-options',
        { agencyEmail: email },
        { withCredentials: true }
      );

      // Step 2: Use browser WebAuthn to get assertion
      const authResponse = await startAuthentication(options);

      // Step 3: Send assertion to backend for verification
      const { data } = await axios.post(
        '/api/agency/verify-agency-login',
        authResponse,
        { withCredentials: true }
      );

      if (data.success) {
        setMessage(`Welcome, ${data.agencyName}`);
        navigate('/agency/dashboard');
      }
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.error || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded shadow">
      <h2 className="text-xl font-bold mb-4">Agency Login</h2>
      <input
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="Enter agency email"
        className="w-full mb-3 p-2 border rounded"
      />
      <button
        onClick={handleLogin}
        disabled={loading}
        className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
      >
        {loading ? 'Logging in...' : 'Login with YubiKey / Windows Hello'}
      </button>
      {message && <p className="mt-4 text-center text-red-600">{message}</p>}
    </div>
  );
}
